import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {UserMappingService} from '../services/usermapping.service';

@Component({
  selector: 'app-create-user-dialog',
  templateUrl: './create-user-dialog.component.html',
  styleUrls: ['./create-user-dialog.component.css']
})
export class CreateUserDialogComponent implements OnInit {

  form: UntypedFormGroup;
  givenName: string = "";
  surName: string = "";
  employmentNumber: string = "";
  employmentNumberExists: boolean = false;

  name: string;
  loginId: string;
  active: boolean = true;
  airportsValues = ['ARN'];  //Only this for now
  skillsValues = ['AIR', 'KOOR', 'LAND', 'LKOO'];
  skills = new UntypedFormControl(null, Validators.required);
  airports = new UntypedFormControl(null, Validators.required);
  permissions = new UntypedFormControl([]);

  isAdmin: Boolean; //Used for showing Permissions option
  permissionValues = ['Planners', 'Dispatcher'];

  constructor(
    public dialogRef: MatDialogRef<CreateUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    fb: UntypedFormBuilder,
    private readonly toastr: ToastrService,
    private readonly usermappingService: UserMappingService) {

    console.log(data);

    this.form = fb.group({
      givenName: new UntypedFormControl(this.givenName, Validators.required),
      surName: new UntypedFormControl(this.surName, Validators.required),
      employmentNumber: new UntypedFormControl(this.employmentNumber, [Validators.required, Validators.pattern(/^\d{4}$/)]),
      active: new UntypedFormControl(this.active),
      skills: this.skills,
      airports: this.airports,
      name: new UntypedFormControl({value: this.name, disabled: true}),
      loginId: new UntypedFormControl({value: this.loginId, disabled: true}),
      currentAirportID: new UntypedFormControl({value: data.userMapping.currentAirportID}, Validators.required),
      permissions: this.permissions
    });

    const control = this.form.get("currentAirportID");            // Make it validate
    control.markAsTouched({onlySelf: true});

  }

  ngOnInit() {
  }

  focusOutName() {
    console.log(this.form);
    let suggestedName;
    let givenName: string = this.form.controls.givenName.value;
    let surName: string = this.form.controls.surName.value;

    if (givenName.length > 0 && surName.length > 0) {
      this.usermappingService.getUniqueIdentity(`${this.form.controls.givenName.value} ${this.form.controls.surName.value}`).then(res => {
        suggestedName = res.name;
        this.loginId = res.loginId;
        this.form.patchValue({name: suggestedName});
        this.form.patchValue({loginId: this.loginId});
      });

    }

  }

  focusOutNumber() {
    console.log(this.form);
    //this.form.patchValue({name: `${this.form.controls.givenName.value} ${this.form.controls.surName.value}`});

    let number: string = this.form.controls.employmentNumber.value;

    if (number.length > 0) {
      this.usermappingService.employmentNumberExists(number).then(res => {
        this.employmentNumberExists = res;
        if (res == true) {
          this.form.controls.employmentNumberExits.setErrors({'incorrect': true});
        } else if (this.form.controls.employmentNumber.valid) {
          this.form.controls.employmentNumber.setErrors(null);
        }
      });

    }

  }

  submit() {
    console.log(this.form);
    console.log(this.data.userMapping);

    if (this.form.valid) {

      let userData = {
        givenName: this.form.controls.givenName.value,
        surName: this.form.controls.surName.value,
        active: this.form.controls.active.value,
        employmentNumber: this.form.controls.employmentNumber.value,
        currentAirportID: this.form.controls.currentAirportID.value,
        airports: this.airports.value,
        skills: this.skills.value,
        memberOf: this.form.controls.permissions.value

      };

      console.log(userData);

      let newUserMapping = this.usermappingService.createUser(userData).then(res => {
        this.toastr.success('Användaren har skapats', 'Användare');
      }).catch(res => {
        this.toastr.error('Fel! Något gick fel när lösenordet är nollställdes', 'Användare');
      });

      this.dialogRef.close(newUserMapping);

    }
  }
}
